export enum DisplayModes {
  This = 'this',
  SideBySide = 'sidebyside',
  Diff = 'diff',
}
